import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import SellingPrice from "../../../containers/modules/sales/selling-price";

export default function SellingPriceRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="selling-price"
      index
      element={
        <AccessControl
          name={"Selling Price List"}
          auth={authUser}
          component={() => <SellingPrice authUser={authUser} />}
        />
      }
    />
  );
}
